webpackJsonp([207771298829211],{

/***/ 365:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulFuneral":{"title":"Funeral","slug":"funeral","metaDescription":"Killasser Parish Church Funeral Information","headerBackgroundImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/6NHL5TRbc4S0iOQGg8AkcS/6c2c78e4e7eb5a2a506867db4ce0e348/art-cathedral-christ-cropped.jpg"}},"sectionFourHeading":"Funeral Info","sectionFourContent":{"childMarkdownRemark":{"html":"<p>When a funeral occurs, the undertaker informs the priest of the day and time the family wish the funerl to take place. </p>"}}}},"pathContext":{"slug":"/funeral/","langKey":"en-US"}}

/***/ })

});


// WEBPACK FOOTER //
// path---funeral-da1098d4b4b762db25e3.js